/**
 * Component that displays a list of AGM pairs that had potential issues with their real chain distances. If the distance between their real chain values is less than the haversine distance between both lat/long points, they will show up on this list for the user to look into further.
 * 
 * @param {Object[]} realChainValidationErrors - array of objects that contain data about agms with real chain validation issues
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */

export const RealChainValidationErrors = ({validationErrors}) => {
    return(
        <div className="my-12">

        {/* explanation of the problem, figured it was too long to put in the warning modal */}

        <div className='border border-gray-300 p-8 mb-10'> 
            <p className="text-md font-bold text-gray-800 mb-4"><i className="fa-solid fa-circle-exclamation mr-2 text-red-500" ></i>Potential issues with Real Chain</p>

            {/* this explanation can be changed if the wording isn't quite right */}
            <p className='text-sm mb-4'>The distance between each pair of sites was calculated in two ways during data validation: </p>

            <ol className='text-sm mb-4'>
                <li className='ml-2'>1. The real chain values for the two sites were subtracted</li>
                <li className='ml-2'>2. The haversine distance was calculated from the latitude and longitude values for each site</li>
            </ol>

            <p className='text-sm'>The cases where the real chain distance is <i>less than</i> the haversine distance are shown below. </p>
        </div>

        {/* list of agm pairs and the distances calculated between them */}

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>

            {validationErrors.map((error, index) => (
                <div key={index}>
                    <p className="font-semibold text-sm">From {error.agm1} to {error.agm2}</p>
                    <p className="text-sm">Distance calculated from Real Chain: <span className='font-semibold'>{error.realChainDist}</span> km</p>
                    <p className="text-sm">Distance calculated from lat/lng: <span className='font-semibold'>{error.latLongDist}</span> km</p>
                    <p className="text-sm mt-2">Difference: <span className='font-bold text-red-500'>{Math.abs(Number(error.realChainDist) - Number(error.latLongDist)).toFixed(3)} km</span></p>
                    <br />
                </div>
            ))}
        </div>

    </div>
    )
}